<template>
    <div class="about-page" style="padding-top: 56px">
        <PricesComponent />
    </div>
</template>
  
<style lang="scss" scoped>
</style>